import { render } from "./yousrPay.vue?vue&type=template&id=69221aad&scoped=true"
import script from "./yousrPay.vue?vue&type=script&lang=js"
export * from "./yousrPay.vue?vue&type=script&lang=js"

import "./yousrPay.vue?vue&type=style&index=0&id=69221aad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69221aad"]])

export default __exports__